import { render, staticRenderFns } from "./DownloadMultipleFiles.vue?vue&type=template&id=494db131&"
import script from "./DownloadMultipleFiles.vue?vue&type=script&lang=js&"
export * from "./DownloadMultipleFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports